// extracted by mini-css-extract-plugin
export default {"button":"apple-pay-button_button__84045","applePayButton":"apple-pay-button_applePayButton__2df7a"};